module.exports = __webpack_public_path__ + "media/images/bg/patterns/chessboard-af70ff6138de4208ba7fa0666d12d163.svg";